import { PathWithId } from "@constellation-academy/epic-ui";
import { LevelDefinitionEditPath } from "../level-definition-edit/level-definition-edit.paths";

export class LevelDefinitionPath extends PathWithId<typeof LevelDefinitionPath> {
	static readonly pathKey = "levelDefinition";
	static readonly pathName = "level-definition";
	static readonly idKey = "levelId";
	static readonly childPaths = [LevelDefinitionEditPath];
}
